import { Layout } from "antd";
import SideNavBar from "../../Components/SideBar/Sidebar";
import Navbar from "../../Components/Support/Header";
import UserTable from "../../Components/UserManagement/UserTable";
import UserCreation from "../../Components/UserManagement/UserCreation";
// import "./UserManagement.css";
import "../../GlobalCss/SPF/UserManagement.css";

const UserManagementPage = () => {
    const { Header, Content } = Layout;
    return (
        <div className="timecards-container">
            <Layout >
                <SideNavBar />
                <Layout className="timecards-sub-layout-container">
                    <Header className="timecards-header">
                        <Navbar />
                    </Header>
                    <Content >
                        <div>
                            <UserCreation />
                            <div className="Flex-Center">
                                <UserTable />
                            </div>
                        </div>
                    </Content>
                </Layout>
            </Layout>
        </div>
    )
}

export default UserManagementPage;